import styled from "styled-components";
import { Wrapper } from 'AppReact';

export const template = styled.div`
  width: 100%;
  border: 1px solid #E3E3E3;
  overflow: hidden;
  border-radius: 8px;
  height: 48px;
  display: flex;
  align-items: center;

  div:last-child {
    border-right: none;
  }
`;

export default Wrapper(template);